<template>
  <div id="app">
    <component v-bind:is="componentName1"></component>
    <!-- <navBarPage/> -->
    <router-view />
    <!-- <footerPage/> -->
    <component v-bind:is="componentName2"></component>
  </div>
</template>

<script>
import footerPage from "./components/footerPage.vue";
import navBarPage from "./components/navBarPage.vue";
import footerPageEn from "./components/footerPageEn.vue";
import navBarPageEn from "./components/navBarPageEn.vue";

export default {
  name: "App",
  components: { footerPage, navBarPage, footerPageEn, navBarPageEn },
  data() {
    return {
      componentName1: "",
      componentName2: "",
    };
  },
  created() {
    // 加载组件
    this.comComFunc();
    //判断当前 设备是pc还是移动 决定要不要跳转
    let goUrl = this.isMobile();
    // if (goUrl === 1 ){

    //   let url =  window.location.href.split('/#/')[0]

    //   let hrf =  url.split("//")[1]

    //   if( hrf.indexOf('www.') != -1){
    //     hrf = hrf.split('www.')[1]
    //   }

    //   if(window.location.hash.indexOf('/en') != -1){//英文
    //     window.location.href  = url.split("//")[0] + "//mobile."+ hrf + "/#/en"
    //   }else{//中文
    //     window.location.href  = url.split("//")[0] + "//mobile."+ hrf + "/#/"
    //   }

    // }
  },
  computed: {
    pageId() {
      return this.$store.state.pageId;
    },
  },
  watch: {
    $route(to, from) {
      console.log(to);
      this.comComFunc();
    },
    pageId(n, o) {
      if (n) {
        if (this.$el.querySelector(n)) {
          this.$el.querySelector(n).scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    },
  },
  mounted() {
    //监视滚动距离
    window.addEventListener("scroll", this.getScroll);
  },
  methods: {
    comComFunc() {
      if (window.location.hash.indexOf("/en") != -1) {
        //英文
        this.componentName1 = "navBarPageEn";
        this.componentName2 = "footerPageEn";
      } else {
        //中文
        this.componentName1 = "navBarPage";
        this.componentName2 = "footerPage";
      }
    },
    // 监听当前 滚动位置
    getScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.$store.commit("saveTopHeight", scrollTop);
    },
    // 判断当前是移动端还是pc端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
  },
};
</script>

<style>
#app {
  font-family: "SourceHanSansCN";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue